module.exports = __webpack_public_path__ + "static/media/hardy-app-demo-full.19a6e98e.mp4";